"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const getContentType_1 = require("../helpers/getContentType");
const validateUser_1 = require("../helpers/validateUser");
const entity_1 = require("../type/entity");
const channelCardZeroState_1 = tslib_1.__importDefault(require("./nodeZeroState/channelCardZeroState"));
const checkpointZeroState_1 = tslib_1.__importDefault(require("./nodeZeroState/checkpointZeroState"));
const iltZeroState_1 = tslib_1.__importDefault(require("./nodeZeroState/iltZeroState"));
const pathZeroState_1 = tslib_1.__importDefault(require("./nodeZeroState/pathZeroState"));
const nonExistingNonRootZeroStatesOfILT_1 = require("./nonExistingNonRootZeroStatesOfILT");
const nonExistingNonRootZeroStatesOfOffer_1 = require("./nonExistingNonRootZeroStatesOfOffer");
const zeroStatesOfOffer_1 = require("./zeroStatesOfOffer");
function zeroStates(content, user) {
    validateUser_1.validateUser(user, { caller: 'zeroState' });
    const contentType = getContentType_1.getContentType(content);
    switch (contentType) {
        case entity_1.ContentType.COURSE:
            return zeroStatesOfOffer_1.zeroStatesOfOffer(content, user);
        case entity_1.ContentType.CURRICULUM:
            return [pathZeroState_1.default(content, user)];
        case entity_1.ContentType.CHECKPOINT:
            return [checkpointZeroState_1.default(content, user)];
        case entity_1.ContentType.ILT:
            return [iltZeroState_1.default(content, user)];
        case entity_1.ContentType.CHANNEL_CARD:
            return [channelCardZeroState_1.default(content, user)];
        default:
            console.info('Incorrect content type found', contentType);
    }
    return [];
}
exports.zeroStates = zeroStates;
function nonExistingNonRootZeroStates(content, user, existingStates) {
    validateUser_1.validateUser(user, { caller: 'nonExistingNonRootZeroStates' });
    const contentType = getContentType_1.getContentType(content);
    if (contentType !== entity_1.ContentType.COURSE && contentType !== entity_1.ContentType.ILT) {
        return [];
    }
    switch (contentType) {
        case entity_1.ContentType.COURSE:
            return nonExistingNonRootZeroStatesOfOffer_1.nonExistingNonRootZeroStatesOfOffer(content, user, existingStates);
        case entity_1.ContentType.ILT:
            return nonExistingNonRootZeroStatesOfILT_1.nonExistingNonRootZeroStatesOfILT(content, user, existingStates);
        default:
            console.info('Incorrect content type found', contentType);
    }
    return [];
}
exports.nonExistingNonRootZeroStates = nonExistingNonRootZeroStates;
//# sourceMappingURL=index.js.map